<template>
  <div>
    <div style="margin-bottom: 10px; margin-top: 10px">
      <el-button @click="exportMaster()">导出</el-button>
    </div>

    <div>
      <el-descriptions :column="4" border size="mini">
        <el-descriptions-item label="日期">
          <el-date-picker v-model="params.month" type="month" value-format="yyyy-MM-dd" placeholder="选择月">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="类型">
          <el-select v-model="params.master_id" placeholder="请选择">
            <el-option value="210" label="顶岗流程（环卫）" />
            <el-option value="211" label="加班审批流程（环卫）" />
          </el-select>
        </el-descriptions-item>
      </el-descriptions>
    </div>


    <div style="margin-top: 10px;">
<!--      <span style="color:red">加载中...</span>-->
    </div>
<!--    <el-table ref="Table" v-if="list" :data="list" height="680px">-->
<!--      <el-table-column prop="project" label="项目" align="center"></el-table-column>-->
<!--      <el-table-column prop="name"label="姓名" align="center"></el-table-column>-->
<!--      <el-table-column prop="phone_number"label="手机" align="center"></el-table-column>-->
<!--      <el-table-column label="权限" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          <span v-if="scope.row.role == 1">主管</span>-->
<!--          <span v-if="scope.row.role == 2">经理</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column label="操作" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button size="mini" type="danger" style="color: #FFFFFF" @click="del(scope.row.role_id)">删除</el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--    </el-table>-->
<!--    <el-pagination background layout="total, prev, pager, next, jumper, sizes"  class="pagination"-->
<!--                   :total="params.total"-->
<!--                   :current-page="params.page"-->
<!--                   :page-size="params.pageSize"-->
<!--                   :page-sizes="[50, 100, 500]"-->
<!--                   @current-change="handleCurrentChange" @size-change="handleSizeChange"/>-->

  </div>
</template>
<script>
import Http from "../common/Http";

export default {
  name: 'EnvironmentalList',
  data() {
    return {
      params: {
        month: "",
        master_id: "",
        total: 0,
        page: 1,
        pageSize: 20
      },
      list: [],
    }
  },
  //界面没出来前加载
  created() {

  },
  mounted() {
    let date = new Date();
    let month = date.getMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    this.params.month = date.getFullYear() + '-' + month;
    this.getList()

  },
  methods: {

    search() {
      this.params.page = 1;
      this.getList()
    },

    getList() {
      // let params = this.params
      // Http.get(Http.getPreBaseURL() + '/oa/user/getUserRoleList', params, res => {
      //   if (res.code === 0) {
      //     this.list = res.data.data;
      //     this.params.page = res.data.current_page;
      //     this.params.pageSize = res.data.per_page;
      //     this.params.total = res.data.total;
      //   } else {
      //     this.$message.error({
      //       message: res.msg,
      //       type: "error",
      //     })
      //   }
      // })
    },

    handleCurrentChange(val) {
      this.params.page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.params.pageSize = val
      this.getList()
    },

    exportMaster() {
      // Http.get(Http.getPreBaseURL() + "/oa/Environmental/exportExecl", this.params, res => {
      Http.get(Http.getPreBaseURL() + "/oa/Environmental/exportExecl", this.params, res => {
        if (res) {
          window.open(Http.getPreBaseURL() + res.data)
          this.$message({
            message: '导出成功',
            type: 'success'
          });
        } else {
          this.$message.error({
            message: '导出失败',
            type: "error",
          });
        }
      })
    },

  }
}
</script>
<style lang="scss" scoped>
$widths: 100px;
.month-table {
  border-color: gray;
  border-collapse: separate;
  user-select: none;
  font-size: 12px;
  min-width: 1200px;
  min-height: 100px;

  tr:hover {
    td.fixed {
      background-color: #dddddd;
      border: 1px solid #ebeef5;
      color: #000;
    }
  }

  th, td {
    min-width: 24px;
    padding: 5px 0px;

    &.fixed {
      position: sticky;
      cursor: pointer;
      z-index: 2;
    }
  }

  th {
    background: #f5f7fa;
    color: #909399;
    border: 1px solid #ebeef5;

    &.hover {
      background-color: #ffebbe;
      color: #333;
    }
  }

  td {
    color: #606266;
    background: #fff;
    border-bottom: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
    text-align: center;
    overflow: hidden;

    &:first-child {
      border-left: 1px solid #ebeef5;
    }

    &.day-item {
      &.check {
        //background: #fafafa;
        opacity: .5;
      }

      &.changed {
        background: #fd9dca;
        color: #333;
      }

      &.selected {
        background: #409eff;
        color: #409eff;
      }
    }

    &.fixed {
      background-color: #fafafa;
    }

    .work-class-label {
      display: inline-block;
    }
  }

  .department-name {
    box-sizing: border-box;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 78px;
    padding: 0 3px;
    line-height: 20px;
  }

  &.show-department {
    .department-name {
      text-overflow: unset;
      overflow: visible;
      white-space: normal;
      width: 198px;
    }
  }

  .inp {
    box-sizing: border-box;
    width: 100%;
    min-width: 50px;
    text-align: center;
    border: 1px solid #fff;
    outline: none;
    font-size: 12px;
    border-radius: 3px;

    &:hover, &:focus {
      border-color: #ccc;
    }
  }

  .w80 {
    display: inline-block;
    width: 79px;
  }

}

.day-head {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/Environmental/List.vue